function sortDataByDate(chartDoc) {
  const { data } = chartDoc.chart;
  // TODO: review this unused branch
  if (data.categoriesAreDates) {
  }
  return chartDoc;
}

export default sortDataByDate;
